import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { SlingConfigChangeLogService } from 'src/app/services/sling-config-change-log.service';
import { StorageUtil } from 'src/app/utils/storage.util';

@Component({
  selector: 'app-sling-config-change-log',
  templateUrl: './sling-config-change-log.component.html',
  styleUrls: ['./sling-config-change-log.component.scss']
})
export class SlingConfigChangeLogComponent implements OnInit, OnDestroy {

  logs: any[] = [];
  rangeLogDate: Date[];
  loading = false;

  filter = {
    marinaId: 0,
    startDate: new Date(),
    endDate: new Date()
  };

  private unsubscriber: Subscription = new Subscription();

  constructor(
    private spinner: NgxSpinnerService,
    private slingConfigChangeLogService: SlingConfigChangeLogService
  ) {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    this.rangeLogDate = [startDate, endDate];
    this.filter.startDate = startDate;
    this.filter.endDate = endDate;
  }

  async ngOnInit(): Promise<void> {
    const marina = StorageUtil.getMarina();
    this.filter.marinaId = marina.id;
  }

  find() {
    this.onChangeLogDate();
    if (!this.filter.startDate || !this.filter.endDate) {
      return;
    }

    this.loading = true;
    this.spinner.show();

    this.unsubscriber.add(
      this.slingConfigChangeLogService.findByMarinaIdAndDateRange(
        this.filter.marinaId,
        this.filter.startDate,
        this.filter.endDate
      ).subscribe(
        (res: any) => {
          this.logs = Array.isArray(res) ? res : [];
          this.loading = false;
          this.spinner.hide();
        },
        (err: HttpErrorResponse) => {
          console.error('Erro ao buscar logs:', err);
          this.logs = [];
          this.loading = false;
          this.spinner.hide();
        }
      )
    );
  }

  onChangeLogDate() {
    if (this.rangeLogDate && this.rangeLogDate.length === 2) {
      if (this.rangeLogDate[0] != null) {
        this.filter.startDate = this.rangeLogDate[0];
        if (this.rangeLogDate[1] != null) {
          this.filter.endDate = this.rangeLogDate[1];
          this.filter.endDate.setHours(23, 59, 59, 999);
        } else {
          this.filter.endDate = this.rangeLogDate[0];
          this.filter.endDate.setHours(23, 59, 59, 999);
        }
      } else {
        this.filter.startDate = null;
        this.filter.endDate = null;
      }
    }
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }
}
